import React, {useEffect, useState, forwardRef, useCallback, useImperativeHandle} from 'react';
import DroppableList from '../DraggingWrappers/DroppableList';
import styles from "../Merging.module.css";
import ExampleGameTemporary from "../ExampleGameTemporary/ExampleGameTemporary";
import PulsingDivWrapper from "../DraggingWrappers/PulsingDivWrapper";

const ExampleGamesMergingDisplay = forwardRef(({patternSelected, fromPattern, toPattern}, ref) => {
    const [fromList, setFromList] = useState([]);
    const [toList, setToList] = useState([]);
    const [draggingTo, setDraggingTo] = useState(false)
    const [draggingFrom, setDraggingFrom] = useState(false)

    const existsInToList = useCallback((item) => {
        return (
            Array.isArray(toList) &&
            item && item.game &&
            toList.some(f => (+item.game.game_id === +f.game.game_id))
        );
    }, [toList]);

    const existsInFromList = useCallback((item) => {
        return (
            Array.isArray(fromList) &&
            item && item.game &&
            fromList.some(f => (+item.game.game_id === +f.game.game_id))
        );
    }, [fromList]);

    const existsInToPattern = useCallback((item) => {
        return (
            toPattern &&
            Array.isArray(toPattern.example_games) &&
            item && item.game &&
            toPattern.example_games.some(f => (+item.game.game_id === +f.game_id))
        );
    }, [toPattern]);

    useEffect(() => {
        if (fromPattern && fromPattern.example_games) {
            setFromList(fromPattern.example_games.map((game, index) => {
                const id = game.game_id + " - Example Game"
                const isGrayed = existsInToList({game: game})
                return {
                    id,
                    game,
                    content: <div className={isGrayed ? styles.GrayedOut : ''}>
                        <ExampleGameTemporary update={handleGameUpdate} exampleGame={game} fromStyles={!existsInToList({game: game})} liveEdit/>
                    </div>,
                    index,
                    disableDrag: isGrayed
                }
            }))
        }
    }, [fromPattern, patternSelected, existsInToList]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (toPattern && toPattern.example_games) {
            setToList(toPattern.example_games.map((game, index) => {
                const id = game.game_id + " - Design Problem"
                return {
                    id,
                    game,
                    content: <div>
                        <ExampleGameTemporary update={handleGameUpdate} exampleGame={game} isMerging liveEdit/>
                    </div>,
                    index,
                    disableDrag: true
                }
            }))
        }
    }, [toPattern, patternSelected]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleGameUpdate = (game) => {
        setToList((prevToList) =>
            prevToList.map((item) => {
                if (+game.id === +item.game.game_id) {
                    const newGame = {
                        ...item.game,
                        example_description: game.description ? game.description : item.game.example_description || "",
                        design_problems: game.select ? game.select.map(val => val.value) : item.game.design_problems || [],
                        secondary_games: game.secondary && game.secondary.length > 0 ? game.secondary.map(sec => sec.game) : (item.game.secondary_games || [])
                    }
                    return {
                        ...item,
                        game: newGame,
                        content: <div>
                            <ExampleGameTemporary update={handleGameUpdate} exampleGame={newGame} isMerging fromStyles={existsInFromList(item) && !existsInToPattern(item)} liveEdit/>
                        </div>,
                    };
                }
                return item;
            })
        );
    }

    const moveItemBetweenLists = (item, start, destination) => {
        if (start === destination) {
            return;
        }
        if (start === 'fromList' && destination === 'toList' && !existsInToList(item)) {
            const newGame = {...item.game}
            const newItem = {
                ...item,
                index: toList.length,  // Set the new index here
                game: newGame,
                content: (
                    <div>
                        <ExampleGameTemporary update={handleGameUpdate} exampleGame={newGame} isMerging fromStyles={true} liveEdit/>
                    </div>
                ),
                disableDrag: false
            };

            setToList((prevToList) => [newItem, ...prevToList]);  // Add item to `toList`
        } else if (start === 'toList' && destination === 'fromList' && existsInFromList(item)) {
            setToList(prev => prev.filter(p => +p.game.game_id !== +item.game.game_id))
        }
    };


    useImperativeHandle(ref, () => ({
        getList: () => {
            return toList.map(item => item.game);  // Return the current state of toList
        }
    }));

    return (
        <div className={styles.Container}>
            <div className={styles.SplitCols}>
                <h3>Example Games:</h3>
                <PulsingDivWrapper active={draggingFrom}>
                    <DroppableList
                        list={toList}
                        setList={setToList}
                        itemType={'EXAMPLE_GAMES'}
                        targetListName="toList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        noStyle
                        setDragging={setDraggingTo}
                    />
                </PulsingDivWrapper>
            </div>
            <div className={styles.Separator}></div>
            <div className={styles.SplitCols}>
                <h3>Example Games:</h3>
                <PulsingDivWrapper active={draggingTo}>
                    <DroppableList
                        list={fromList}
                        setList={setFromList}
                        itemType={'EXAMPLE_GAMES'}
                        targetListName="fromList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        noStyle
                        setDragging={setDraggingFrom}
                    />
                </PulsingDivWrapper>
            </div>
        </div>
    )
});

export default ExampleGamesMergingDisplay;
